import { render } from "./PutPage.vue?vue&type=template&id=3b20dc42&scoped=true&ts=true"
import script from "./PutPage.vue?vue&type=script&lang=ts"
export * from "./PutPage.vue?vue&type=script&lang=ts"

import "./PutPage.vue?vue&type=style&index=0&id=3b20dc42&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/pontuei/pontuei-painel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b20dc42"]])

export default __exports__